import React, { createContext, useContext, useState } from "react";
import { IRoleContext, IRole } from "../exports/interfaces";

const RoleContext = createContext<IRoleContext>({
  roles: [],
  setRoles: () => null,
});

export const useRole = () => useContext(RoleContext);

export const RoleProvider = ({ children }: { children: React.ReactNode }) => {
  const [roles, setRoles] = useState<IRole[]>([]);

  return (
    <RoleContext.Provider value={{ roles, setRoles }}>
      {children}
    </RoleContext.Provider>
  );
};
